import RequestService from '@/service'

export default class ApiDict {
  // 获取 达人标签
  static treeExpertLabel() {
    return RequestService.get({
      url: '/chain/web-init/label-tree'
    })
  }

  // 获取 省市区
  static treeArea() {
    return RequestService.get({
      url: '/chain/web-init/label-address'
    })
  }

  // 获取 达人状态
  static listExportStatus() {
    return RequestService.get({
      url: '/chain/web-init/booger-status'
    })
  }

  // 项目 获取可变更项目博主状态
  static listProjectCanUpdateStatus(params?: { childStatus: string | number; projectBloggersId?: string | number }) {
    return RequestService.get({
      url: '/chain/project-status/get-update-status',
      params
    })
  }

  // 项目 合作标签-缺点
  static listDataByType(params?: { dictType: string; pageNo: number; pageSize: number }) {
    return RequestService.get({
      url: '/chain/system/dict-page',
      params
    })
  }
}
